import alertManagement from "./alertManagement/es";
import assetManagement from "./assetManagement/es";
import assetParing from "./assetParing/es";
import authUser from "./authUser/es";
import billingAddress from "./billingAddress/es";
import configurator from "./configurator/es";
import contact from "./contact/es";
import development from "./development/es";
import deviceManagement from "./deviceManagement/es";
import feedback from "./feedback/es";
import fleetInventory from "./fleetInventory/es";
import fleetManagement from "./fleetManagement/es";
import groups from "./groups/es";
import home from "./home/es";
import manufacturer from "./manufacturer/es";
import map from "./map/es";
import noAccessMessage from "./noAccessMessage/es";
import paring from "./paring/es";
import projects from "./projects/es";
import settings from "./settings/es";
import softwareManagement from "./softwareManagement/es";
import userManagement from "./userManagement/es";

export default {
  alertManagement,
  assetManagement,
  assetParing,
  authUser,
  billingAddress,
  configurator,
  contact,
  development,
  deviceManagement,
  feedback,
  fleetInventory,
  fleetManagement,
  groups,
  home,
  manufacturer,
  map,
  noAccessMessage,
  paring,
  projects,
  settings,
  softwareManagement,
  userManagement,
};
